import React from 'react';
import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap } from 'react-google-maps';
import MapDetailsWrapper from './MapDetailsWrapper';

export const mapApi = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCB-C2df0QoK2pJ1TnRGKXTOexFZDeHY3U&libraries=geometry,drawing,places';

const MapDetailsComponent = compose(
  withProps({
    googleMapURL: mapApi,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div />,
    mapElement: <div style={{ height: '250px' }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(props => (
  <MapDetailsWrapper details={props} />
));

export default MapDetailsComponent;
